"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AfterEffectsCompositionName = void 0;
var AfterEffectsCompositionName;
(function (AfterEffectsCompositionName) {
    AfterEffectsCompositionName["CeremonyPreRoll"] = "Ceremony Pre-Roll";
    AfterEffectsCompositionName["CeremonyPostRoll"] = "Ceremony Post-Roll";
    AfterEffectsCompositionName["ClipPreRoll"] = "Clip Pre-Roll";
    AfterEffectsCompositionName["ClipPostRoll"] = "Clip Post-Roll";
})(AfterEffectsCompositionName = exports.AfterEffectsCompositionName || (exports.AfterEffectsCompositionName = {}));
//# sourceMappingURL=after-effects-composition-name.js.map